import React from 'react';

class ClearIcon extends React.Component {
  constructor(props) {
    super(props);
    this.handleClear = this.handleClear.bind(this);
  }

  handleClear() {
    this.props.onClear();
  }

  render() {
    const hidden = this.props.hidden;
    return (
      <button className="focus:outline-none" onClick={this.handleClear}>
        <img src="../assets/close.svg" alt="search icon" className="w-4 h-auto mr-2 sm:w-6 md:w-8 lg:w-6" hidden={hidden} />
      </button>
    );
  }
}

class SearchBar extends React.Component {
  constructor(props) {
    super(props);
    this.handleSearchInput = this.handleSearchInput.bind(this);
    this.clearInput = this.clearInput.bind(this);
    this.state = {
      hidden: true,
      value: ''
    }
  }

  handleSearchInput(e) {
    const val = e.target.value;
    this.props.onSearchInput(val);
    val !== '' ?
      this.setState({
        value: val,
        hidden: false
      }) :
      this.setState({
        value: '',
        hidden: true
      });
  }

  clearInput() {
    this.setState({
      hidden: true,
      value: '',
    })
    this.props.onSearchInput('');
  }

  render() {
    const theme = this.props.theme;
    return (
      theme ?
        <div className="bg-white flex jusstify-around mx-4 mt-4 p-3 shadow-md rounded-md transition-colors duration-300 sm:mt-6 md:mt-8 lg:w-1/2 lg:mx-0">
          <img src="../assets/search.svg" alt="search icon" className="w-4 h-auto mr-2 sm:w-6 md:w-8 lg:w-6" />
          <input type="text" placeholder="Search for a country..."
            className="bg-transparent text-xs w-full focus:outline-none sm:text-lg md:text-xl lg:text-base"
            value={this.state.value}
            onChange={this.handleSearchInput}
          />
          <ClearIcon hidden={this.state.hidden} onClear={this.clearInput} />
        </div> :
        <div className="bg-gray-800 flex jusstify-around mx-4 mt-4 p-3 shadow-md rounded-md transition-colors duration-300 sm:mt-6 md:mt-8 lg:w-1/2 lg:mx-0">
          <img src="../assets/search-white.svg" alt="search icon" className="w-4 h-auto mr-2 sm:w-6 md:w-8 lg:w-6" />
          <input type="text" placeholder="Search for a country..."
            className="bg-transparent text-xs text-gray-400 w-full focus:outline-none sm:text-lg md:text-xl lg:text-base"
            value={this.state.value}
            onChange={this.handleSearchInput}
          />
          <ClearIcon hidden={this.state.hidden} onClear={this.clearInput} />
        </div>
    );
  }
}

export default SearchBar;
